import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

import JobApplicationList from "./JobApplicationList"

const LAYOUTS = [
    {
        id: 'table',
        label: 'Table',
        icon: (
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                <rect x="1.5" y="2" width="13" height="12" rx="1.5" />
                <path d="M1.5 6.25h13M6.25 6.25v7.75" />
            </svg>
        )
    },
    {
        id: 'compact',
        label: 'Compact',
        icon: (
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                <rect x="1.5" y="2" width="4" height="3" rx="0.5" />
                <path d="M7.25 3.5H14.5" />
                <rect x="1.5" y="6.5" width="4" height="3" rx="0.5" />
                <path d="M7.25 8H14.5" />
                <rect x="1.5" y="11" width="4" height="3" rx="0.5" />
                <path d="M7.25 12.5H14.5" />
            </svg>
        )
    },
    {
        id: 'grid',
        label: 'Grid',
        icon: (
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                <rect x="1.5" y="1.5" width="5.25" height="5.25" rx="0.75" />
                <rect x="9.25" y="1.5" width="5.25" height="5.25" rx="0.75" />
                <rect x="1.5" y="9.25" width="5.25" height="5.25" rx="0.75" />
                <rect x="9.25" y="9.25" width="5.25" height="5.25" rx="0.75" />
            </svg>
        )
    }
]

const readStoredLayout = () => {
    try {
        const stored = window.localStorage.getItem('videebop.applicantsLayout')
        if (stored === 'scan') return 'compact'
        if (['table', 'compact', 'grid'].includes(stored)) return stored
    } catch (e) {}
    return 'table'
}

const DemoApplicantBoard = (props) => {
    const [layout, setLayout] = useState('table')

    useEffect(() => {
        setLayout(readStoredLayout())
    }, [])

    const chooseLayout = (id) => {
        setLayout(id)
        try {
            window.localStorage.setItem('videebop.applicantsLayout', id)
        } catch (e) {}
    }

    return (
        <div>
            <div className="applicants-toolbar applicants-toolbar--demo">
                <div className="applicants-layout" role="radiogroup" aria-label="Applicant layout">
                    {LAYOUTS.map((item) => (
                        <button
                            type="button"
                            role="radio"
                            aria-checked={layout === item.id}
                            key={item.id}
                            className={`applicants-layout__btn${layout === item.id ? ' is-active' : ''}`}
                            title={item.label}
                            aria-label={item.label}
                            onClick={() => chooseLayout(item.id)}
                        >
                            {item.icon}
                            <span className="applicants-layout__label">{item.label}</span>
                        </button>
                    ))}
                </div>
            </div>
            <div className={`applicants-view applicants-view--${layout}`}>
                <JobApplicationList
                    jobApplications={props.jobApplications}
                    allowToggle={props.allowToggle}
                    onModalOpen={props.onModalOpen}
                    layout={layout}
                />
            </div>
        </div>
    )
}

DemoApplicantBoard.propTypes = {
    jobApplications: PropTypes.array.isRequired,
    allowToggle: PropTypes.bool,
    onModalOpen: PropTypes.func
}

DemoApplicantBoard.defaultProps = {
    allowToggle: false
}

export default DemoApplicantBoard
